<template>
  <div class="page dataList inventoryInquire">
    <!-- <div class="p16">
      <p style="font-weight: bold;">库存报表查询<span class="moneys fontSize14">（今日数据将在次日0点更新）</span></p>
    </div> -->
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">库存查询&nbsp;/&nbsp;</span>
      </div>
      <div>库存报表查询 <span class="moneys fontSize14">（今日数据将在次日0点更新）</span></div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs br10">
            <div class="titles">
              <p class="order-title-boxs"><span class="blueBlock"></span><i>{{form.productName}}</i></p>
              <v-date @time="change" :clearable="false" class="ml10"></v-date>
            </div>
            <div class="flex-row pl24">
              <div>耗材/产品：{{form.productTypeCn}}</div>
              <div class="ml50">计量单位：{{form.storageUnit}}</div>
            </div>
            <el-row class="rows">
              <el-col class="cols" :span="4">
                <p class="van-text">期初库存剩余量</p>
                <p class="van-label">{{form.beginningMonthNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">手动入库量</p>
                <p class="van-label">{{form.manualStorageNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">采购总数量</p>
                <p class="van-label">{{form.purchaseNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">销售总数量</p>
                <p class="van-label">{{form.saleNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">赠送总数量</p>
                <p class="van-label">{{form.giveNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">积分兑换总数量</p>
                <p class="van-label">{{form.exchangeNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">手动出库量</p>
                <p class="van-label">{{form.manualWastageNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">盘亏总数量</p>
                <p class="van-label">{{form.lossNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">退货总数量</p>
                <p class="van-label">{{form.refundNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">盘盈总数量</p>
                <p class="van-label">{{form.surplusNum || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">期末库存剩余量</p>
                <p class="van-label">{{form.remainNum || 0}}</p>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";

export default {
  mixins: [minxin],
  data() {
    return {
      form: {},
      query: {
        beginTime: new Date(),
        endTime: new Date(),
        productId: this.$route.query.id
      }
    };
  },
  components: {},
  created() {},
  methods: {
    change(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      this.pageDetailByShop();
    },
    pageDetailByShop() {
      this.$api.post(this.$url.inventoryDay.get, this.query).then(res => {
        if (res) {
          this.form = res;
          if (sessionStorage.getItem("inquireObj")) {
            let obj = JSON.parse(sessionStorage.getItem("inquireObj"));
            this.form.productName = obj.productName;
            this.form.productTypeCn = obj.productTypeCn;
            this.form.storageUnit = obj.storageUnit;
            sessionStorage.removeItem("inquireObj");
          }
        }
      }).catch(error => {});
    },
    back() {
      this.$router.push("/dataList/inventoryInquire");
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.mains-content {
  height: calc(100% - 72px);
}
.inventoryInquire {
  .ml50 {
    margin-left: 50px;
  }
}
</style>